<header>
	@if (appSetting.isMobile) {
		<nav id="navbar" class="navbar navbar-expand-lg fixed-top" style="z-index:1000;">
			<div class="col-12 _jmMobileSideGutters" style="padding: 0; height: 100%;">
				<a href="javascript:void(0);" class="navbar-brand" (click)="goHomehLink()" [style]="{'padding-top': '8px','float':'left','cursor':loggedIn?'pointer':'default'}">
					<img [src]="navigationSrv.logo" style="max-width:223px; height:auto; max-height:58px;">
				</a>
				<div class="ms-auto text-end" style="padding-top:10px;">
					@if (isAnonymous) {
						@if (allowSignup) {
							<button (click)="goto('openSignup')" class="btn btn-lg btn-primary" style="background-color:white; color:#3498db!important; margin-right:5px;">Sign up</button>
						}
						<button (click)="goto('openLogin')" class="btn btn-lg btn-primary">Login</button>
					}
					@if (!isAnonymous) {
						<app-notification></app-notification>
						<div ngbDropdown style="display: inline-block; vertical-align:top;">
							<span ngbDropdownToggle role="button">
								<img [src]="profileImage" class="jmRoundCenterImage">
							</span>
							<div ngbDropdownMenu class="w-100 h-100" style="top: 0; left: 0; background-color: #fff; position: fixed; padding: 5px 15px; border-radius: 0px; margin:0">
								<table class="table table-borderless" style="font-size:18px">
									<tbody>
										<tr>
											<td>
												<div style="display:inline-block">
													<div class="text-truncate" style="font-size: 30px;color: #242424; max-width:250px;">Hi, {{personInfo.FirstName}}</div>
													<app-switch-account currentZone="true"></app-switch-account>
												</div>
												<span style="color: #7F8C8D; float:right" role="button"><i ngbDropdownItem class="icnXMark display-6 text-primary"></i></span>
											</td>
										</tr>
										<tr>
											<td>
												<span ngbDropdownItem class="text-primary" role="button" (click)="goto('dashboard')">Dashboard</span>
											</td>
										</tr>
										<tr>
											<td>
												<span ngbDropdownItem class="text-primary" role="button" (click)="goto('map')">Map</span>
											</td>
										</tr>
										<tr>
											<td>
												<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/MyJourney/List')">My Journeys</span>
											</td>
										</tr>
										<tr>
											<td>
												<span ngbDropdownItem role="button" (click)="goto('/User/Profile')" style="color: #242424; font-weight: 700;">
												<img [src]="profileImage" class="jmRoundCenterImage" style="margin-right: 10px !important; width:25px;">Profile
												</span>
											</td>
										</tr>
										<tr>
											<td>
												<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/User/Portfolio')"><i class="icnStar" aria-hidden="true" style="padding-right: 10px;"></i> Portfolio</span>
											</td>
										</tr>
										<tr>
											<td>
												<a ngbDropdownItem href="https://intercom.help/journeys-acc277045d6d" class="text-primary" target="_blank"><i class="icnLifeRing" aria-hidden="true" style="padding-right: 10px;"></i> Help</a>
											</td>
										</tr>
										@if (isSystemAdmin) {
											<tr>
												<td>
													<span ngbDropdownItem class="text-primary" role="button" (click)="gotoWeb()"><i class="icnUser" aria-hidden="true" style="padding-right: 10px;"></i> System Admin</span>
													@if (loadingWeb) {
														<span class="jmWidgetLoadingIcon20"></span>
													}
												</td>
											</tr>
											<tr>
												<td>
													<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/System/Dashboard')"><i class="icnGear" aria-hidden="true" style="padding-right: 10px;"></i> System Admin Settings</span>
												</td>
											</tr>
										}
										@if(widgetAPI.isWidgetAllowed('Settings')) {
											<tr>
												<td>
													<a ngbDropdownItem class="text-primary" role="button" (click)="goto('/Zone/Settings')"><i class="icnGear" aria-hidden="true" style="padding-right: 10px;"></i> Settings</a>
												</td>
											</tr>
										}
										<tr>
											<td>
												<app-switch-account currentZone="false"></app-switch-account>
											</td>
										</tr>
										<tr>
											<td>
												<button class="btn btn-primary w-100" (click)="logout()" style="margin-top:15px;">Logout <i class="icnRightToBracket"></i></button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					}
				</div>
			</div>
		</nav>
	}

	@if (!appSetting.isMobile) {
		<nav id="navbar" class="navbar navbar-expand-lg fixed-top" style="z-index:1000;">
			<!--matdiag zindex is 1000, so do not overwrite-->
			<div class="row w-100" style="height: 100%;">
				<div class="col-12">
					<div class="row" style="height: 100%;">
						<div class="col-auto d-flex align-items-center">
							<a href="javascript:void(0);" (click)="goHomehLink()" [style]="{'padding-top': '8px','cursor':loggedIn?'pointer':'default'}">
								<div class="_jmMarginL">
									<img [src]="navigationSrv.logo" style="max-width:223px; height: auto; max-height: 58px;">
								</div>
							</a>
						</div>
						<div class="col d-flex">
							<ul class="navbar-nav me-auto _jmPaddingHalfL" id="navbarMyJourneysUl" stlye="height: 100%;">
								<li class="nav-item" style="margin-right:30px; display: flex; align-items: center;">
									<a href="javascript:void(0);" class="nav-link jmNavLink" (click)="goto('dashboard')">Dashboard</a>
								</li>
								<li class="nav-item" style="margin-right: 30px; display: flex; align-items: center;">
									<a href="javascript:void(0);" class="nav-link jmNavLink" (click)="goto('map')">Map</a>
								</li>
								<li class="nav-item" style="display: flex; align-items: center;" id="nbMyJourneys">
									<a href="javascript:void(0);" class="nav-link jmNavLink" (click)="goto('/MyJourney/List')">My Journeys</a>
								</li>
							</ul>
							@if (!isAnonymous) {
								<ul class="navbar-nav _jmPaddingR" style="align-items: center;">
									<li class="nav-item nav-link text-center my-auto" style="min-width: 120px; padding: 0px 10px;">
										<div class="text-truncate mx-auto" style="max-width:200px; color:#fff;">Hi, {{personInfo.FirstName}}</div>
										<app-switch-account currentZone="true"></app-switch-account>
									</li>
									<li class="nav-item">
										<app-notification></app-notification>
									</li>
									@if (!profileReady) {
										<li>
											<i class="nav-link jmRoundCenterBackground" style="color: #fff; background-color: #fff;"></i>
										</li>
									}
									@if (profileReady) {
									<li ngbDropdown class="nav-item">
										<span ngbDropdownToggle role="button"><img [src]="profileImage" class="jmRoundCenterImage"></span>
										<ul ngbDropdownMenu style="width: 260px; padding: 10px; font-size: 16px; left: -200px; overflow-y: unset;">
											<li class="jmArrowUp"></li>
											<li ngbDropdownItem class="jmDropdownItem" (click)="goto('/User/Profile')" role="button"><i class="icnPaperPlane" style="margin-right:10px;"></i>Profile</li>
											<li ngbDropdownItem class="jmDropdownItem" (click)="goto('/User/Portfolio')" role="button"><i class="icnStar" style="margin-right:10px;"></i>Portfolio</li>
											<li ngbDropdownItem class="jmDropdownItem" (click)="goto('help')" role="button"><i class="icnLifeRing" style="margin-right:10px;"></i>Help</li>
											@if (isSystemAdmin) {
												<li ngbDropdownItem class="jmDropdownItem" (click)="gotoWeb()" role="button"><i class="icnUser" style="margin-right: 10px;"></i>System Admin
													@if (loadingWeb) {
														<span class="jmWidgetLoadingIcon20"></span>
													}
												</li>
												<li ngbDropdownItem class="jmDropdownItem" (click)="goto('/System/Dashboard')" role="button"><i class="icnGear" style="margin-right: 10px;"></i>System Admin Settings</li>
											}
											@if(widgetAPI.isWidgetAllowed('Settings')) {
												<li ngbDropdownItem class="jmDropdownItem" (click)="goto('/Zone/Settings')" role="button"><i class="icnGear" style="margin-right: 10px;"></i>Settings</li>
											}
											<li ngbDropdownItem style="background-color:#fff;"><app-switch-account currentZone="false"></app-switch-account></li>
											<li ngbDropdownItem style="padding:9px 9px; background-color:#fff;"><button class="btn btn-primary" (click)="logout()" style="width: 100%; margin-top: 10px;">Logout <i class="icnRightToBracket"></i></button></li>
										</ul>
									</li>
								}
								</ul>
							}
							@if (isAnonymous) {
								<ul class="navbar-nav _jmPaddingR me-2">
									<li class="nav-item  mt-3">
										@if (allowSignup) {
										<button (click)="goto('openSignup')" class="btn btn-lg btn-primary" style="background-color:white; color:#3498db!important; margin-right:20px;">Sign up</button>
										}
										<button (click)="goto('openLogin')" class="btn btn-lg btn-primary">Login</button>
									</li>
								</ul>
							}
						</div>
					</div>
				</div>
			</div>
		</nav>
	}
</header>

